var _excluded = ["className", "short", "left"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from 'react';
import PropType from 'prop-types';
import classnames from 'classnames';

/**
 * Status: *finished*
 * Category: Misc
 *
 * The css-class <code>.horizontal-rule</code> can be used on any element to give it a grey border in bottom of
 * the element, or it can be used on the <code>&lt;hr/&gt;</code> tag as a standalone component.
 * The style should be used to define a thematic break.
 */
var HorizontalRule = function HorizontalRule(_ref) {
  var _classnames;
  var className = _ref.className,
    _short = _ref["short"],
    left = _ref.left,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("hr", _extends({
    className: classnames('horizontal-rule', (_classnames = {}, _defineProperty(_classnames, className, className), _defineProperty(_classnames, 'horizontal-rule--short', _short), _defineProperty(_classnames, 'horizontal-rule--left', left), _classnames))
  }, rest));
};
HorizontalRule.propTypes = {
  /** Whenever this should be short or not. */
  "short": PropType.bool,
  /** Whenever this should be left aligned. */
  left: PropType.bool
};
export default HorizontalRule;